import { Component, Host, Prop, h } from '@stencil/core';

const sizes = {
  sm: 'sportsline-circular-progress--sm',
  md: 'sportsline-circular-progress--md',
};

export type SportslineCircularProgressProps = {
  /**
   * The name of the avatar size.
   * @default 'md'
   */
  size: keyof typeof sizes;
};

@Component({
  tag: 'sportsline-circular-progress',
  styleUrl: 'sportsline-circular-progress.css',
  shadow: true,
})
export class SportslineCircularProgres {
  /**
   * Size of the progress spinner
   */
  @Prop() size: SportslineCircularProgressProps['size'] = 'md';

  private getSizeClass() {
    // Define your size mappings (you can adjust these values as needed)
    return sizes[this.size] ?? sizes.md;
  }

  render() {
    return (
      <Host>
        <div
          class={{
            'sportsline-circular-progress': true,
            [this.getSizeClass()]: true,
          }}
        >
          <div class="sportsline-circular-progress__spinner">
            <span>
              <svg class="MuiCircularProgress-svg css-4ejps8" viewBox="22 22 44 44">
                <circle cx="44" cy="44" r="20" fill="none" stroke-width="4"></circle>
              </svg>
            </span>
            <span>
              <svg class="MuiCircularProgress-svg css-4ejps8" viewBox="22 22 44 44">
                <circle cx="44" cy="44" r="20" fill="none" stroke-width="4"></circle>
              </svg>
            </span>
          </div>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
